namespace Matrix.Workflow {
    export interface QueueField {
        FieldName?: string;
        DisplayName?: string;
        IsRequired?: boolean;
        Updatable?: boolean;
        VisibleInForm?: boolean;
        FormTab?: string;
        FormCategory?: string;
        FormWidth?: string;
        FormWidthUntilNext?: boolean;
        FormWidthJustThis?: boolean;
        LabelWidth?: string;
        LabelWidthUntilNext?: boolean;
        LabelWidthJustThis?: boolean;
        MaxLength?: number;
        DecimalPlaces?: number;
        DateTimeKind?: number;
        EditorType?: string;
        VisibleInGrid?: boolean;
        EditLink?: boolean;
        Width?: number;
        Alignment?: string;
        QuickSearchType?: Serenity.Data.Mapping.SearchType;
        DisplayFormat?: string;
        FormatterType?: string;
        SortOrder?: number;
        GroupOrder?: number;
        DisplayOrder?: number;
        SummaryType?: number;
        ReadPermission?: string;
        ModifyPermission?: string;
        FormatterParams?: { [key: string]: any };
        EditorParams?: { [key: string]: any };
    }
}
